import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core'
import { Favorite, FavoritesService } from '../../services/favorites.service'

@Directive({
  selector: '[jmlFavoriteButton]'
})
export class FavoriteButtonDirective implements OnInit {
  @Input() favoriteId: string
  @Input() favoriteName: string
  @Input() favoriteIcon: string
  @Input() favoriteRoute: string
  @Input() favoriteDtoType?: string

  private iconElement: HTMLElement

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private favoritesService: FavoritesService
  ) {}

  ngOnInit() {
    this.createFavoriteButton()
  }

  private createFavoriteButton() {
    // button-container
    const containerDiv = this.renderer.createElement('div')

    // base-class and class-variant
    this.renderer.addClass(containerDiv, 'fav-icon')

    // icon-element
    this.iconElement = this.renderer.createElement('i')
    this.renderer.addClass(this.iconElement, 'favorite-icon')
    this.renderer.addClass(this.iconElement, 'pi')
    this.updateIconClass()

    // tooltip
    this.renderer.setAttribute(
      this.iconElement,
      'pTooltip',
      this.isFavorite() ? 'Aus Favoriten entfernen' : 'Zu Favoriten hinzufügen'
    )
    this.renderer.setAttribute(this.iconElement, 'tooltipPosition', 'left')

    // add button to container
    this.renderer.appendChild(containerDiv, this.iconElement)

    // add button to host element
    this.renderer.appendChild(this.el.nativeElement, containerDiv)

    // add Event-Listener
    this.iconElement.addEventListener('click', (event) => this.toggleFavorite(event))
  }

  private updateIconClass() {
    if (this.iconElement) {
      // remove existing status classes
      this.renderer.removeClass(this.iconElement, 'pi-star')
      this.renderer.removeClass(this.iconElement, 'pi-star-fill')

      // put class based on favorite status
      this.renderer.addClass(this.iconElement, this.isFavorite() ? 'pi-star-fill' : 'pi-star')
    }
  }

  private isFavorite(): boolean {
    return this.favoritesService.isFavorite(this.favoriteId)
  }

  private toggleFavorite(event: Event) {
    event.stopPropagation()

    const favorite: Favorite = {
      id: this.favoriteId,
      name: this.favoriteName,
      icon: this.favoriteIcon,
      route: this.favoriteRoute,
      dtoType: this.favoriteDtoType
    }

    this.favoritesService.toggleFavorite(favorite)

    // update icon class
    this.updateIconClass()

    // update tooltip
    this.renderer.setAttribute(
      this.iconElement,
      'pTooltip',
      this.isFavorite() ? 'Aus Favoriten entfernen' : 'Zu Favoriten hinzufügen'
    )
  }
}
